import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Table, Button } from 'semantic-ui-react';

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  background: #FFFFFF;
`;

export const Content = styled.div`
  width: 90%;
  max-width: 1100px;

  margin: 6% auto;
`;

export const Title = styled.h1`
  width: 100%;
  margin:0px 0px 15px 0px;
  padding: 0px;

  color:#000000;

  font-size:28px;
  font-family:sans-serif;
  font-weight:600;

  border-bottom: 1px solid rgba(34,36,38,.15);

  display: inline-block;
`;

export const ContainerInputSearch = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  
  & i{
    height: 75% !important;
  }
`;

export const Input = styled.input`
  height:35px;
  width: 100%;
  margin:0;
  padding: .67857143em 1em;
  outline:0;
  background:#FFFFFF;
  color:rgba(0,0,0,.87);
  font-size:13px;
  font-family:sans-serif;
  font-weight:400;
  border:1px solid rgba(34,36,38,.15);
  border-radius:4px;
  -webkit-appearance:none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color .1s ease,border-color .1s ease;
`;
export const Select = styled.select`
  height:35px;
  margin:0;
  padding: .67857143em 1em;
  outline:0;
  background:#FFFFFF;
  color:rgba(0,0,0,.87);
  font-size:13px;
  font-family:sans-serif;
  font-weight:400;
  border:1px solid rgba(34,36,38,.15);
  border-radius:4px;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color .1s ease,border-color .1s ease;
`;

export const CreateButton = styled(Link)`
  width: 100px;
  height: 35px;

  margin-left: 3px;

  color: #000000;
  background: #e0e1e2;

  border-radius: 5px;

  font-family: sans-serif;
  font-size: 16px;
  font-weight: 600;

  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover{
    background: #cacbcd;
    font-weight: 700;
    color: #000000;
  }
`;


export const CardItem = styled.div`
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 100%;
  margin: 0 auto;
  text-align: left;
  background-color: #fff;
  display: flex;
  align-items:center;
  justify-content: flex-start;
  flex-direction:column;
  margin-bottom: 1rem;
  div{
    display:flex;
    align-items:center;
    justify-content:space-between;
    width: 100%;
    margin-bottom: 1rem;
    button {
      width: 100px;
      height: 40px;
      background: none;
      border: 1px solid var(--color-primary);
      border-radius: 5px;
      transition: .3s ease-in-out all;
      &:hover {
        background: var(--color-primary);
        cursor: pointer;
        color: #fff;
      }
    }
  }
  h2 {
    font-size: 20px;
    margin-bottom: 10px;
    font-weight: 500;
    max-width: 650px;
  }
  p {
    font-size: 16px;
  line-height: 1.5;
  color: #333;
  }
  footer{
    display:flex;
    align-items:center;
    justify-content:space-between;
    width: 100%;
    margin-top: 1rem;
  }
`;
export const ContainerPaginate = styled.div`
  display: flex;
  justify-content: center;
`;